export default angular.module('eventix.common.services.safariCacheBuster',[])
/**
 * @ngdoc service
 * @name eventix.common.services.SafariCacheBuster
 * @description
 * Safari caches XHR requests that are close together... So we need to add a query parameter
 */
    .provider('SafariCacheBuster', function() {
        var tokenType = 'credentials';
        /**
     * Implements $httpInterceptor methods for handling OAuth token in every request
     */
        return {
        /**
         * @ngdoc method
         * @name eventix.common.services.OAuthHeadersProvider#setStorageKey
         * @methodOf eventix.common.services.OAuthHeadersProvider
         * @description
         * Configure which token should be sent along with HTTP requests, only `client_credentials` and `password` are currenty supported
         *
         * @param {String} grantType Grant type
         */
            setGrantType: function(grantType) {
                tokenType = grantType;
            },
            $get: /*@ngInject*/ function($rootScope, $q, VisitorData) {
                return {
                /**
                 * Add a oauth header if a token is available
                 *
                 * @param {Object} config HTTP request configuration object
                 * @returns {Object} HTTP request configuration object
                 */
                    request: function(config) {
                        if(/^(https?:)?\/\/|html?$/.test(config.url))
                            return config;

                        // Keep the data call cachable
                        if(/data/.test(config.url))
                            return config;

                        if(config.url.indexOf('?') >= 0)
                            config.url += `&nocache=${Math.random()}`;
                        else
                            config.url += `?nocache=${Math.random()}`;
                        return config;
                    }
                };
            }
        };
    }).name;
